<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-purple">
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <b-card no-body>
            <b-card-header class="border-0">
              <b-row align-v="center" slot="header">
                <b-col cols="4"> </b-col>
                <b-col cols="8" class="text-right">
                  <base-button
                    type="success"
                    @click="exportExcel('jurado-resposta', setLoadingExcel)"
                    :loading="loadingExcel"
                  >
                    Exportar Excel
                  </base-button>
                </b-col>
              </b-row>
            </b-card-header>

            <el-table
              class="table-responsive table"
              header-row-class-name="thead-light"
              :data="data"
              v-loading="loading"
              empty-text="Não há dados para mostrar"
            >
              <el-table-column label="ID" prop="id" min-width="70px">
              </el-table-column>
              <el-table-column
                label="Nome"
                prop="nomeJurado"
                min-width="120px"
              />
              <el-table-column label="Peça" prop="id" min-width="190px">
                <template v-slot="{ row }">
                  <div
                    class="d-flex align-items-center"
                    v-if="row.idPecaPublicitaria"
                  >
                    {{ row.pecaTituloPublicitaria }}
                  </div>
                  <div
                    class="d-flex align-items-center"
                    v-if="row.idPecaFornecedor"
                  >
                    {{ row.pecaTituloFornecedor }}
                  </div>
                  <div
                    class="d-flex align-items-center"
                    v-if="row.idPecaEstudante"
                  >
                    {{ row.pecaTituloEstudante }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="Tipo de Peça" prop="id" min-width="150px">
                <template v-slot="{ row }">
                  <div
                    class="d-flex align-items-center"
                    v-if="row.idPecaPublicitaria"
                  >
                    Peça Publicitária
                  </div>
                  <div
                    class="d-flex align-items-center"
                    v-if="row.idPecaFornecedor"
                  >
                    Peça Fornecedor
                  </div>
                  <div
                    class="d-flex align-items-center"
                    v-if="row.idPecaEstudante"
                  >
                    Peça Estudante
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="Criatividade"
                prop="criatividade"
                min-width="150px"
              />
              <el-table-column
                label="Inovação"
                prop="inovacao"
                min-width="120px"
              />
              <el-table-column
                label="Pertinência"
                prop="pertinencia"
                min-width="130px"
              />

              <el-table-column label="Ações" prop="id" min-width="120px">
                <template v-slot="{ row }">
                  <div class="d-flex align-items-center">
                    <base-button
                      size="sm"
                      type="danger"
                      @click="openDeleteModal(row.id)"
                    >
                      Excluir
                    </base-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <b-card-footer class="py-4 d-flex justify-content-end">
              <base-pagination
                v-model="pagination.page"
                :per-page="pagination.size"
                :total="pagination.totalElements"
                v-on:change="load"
              ></base-pagination>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
      <div class="mt-5"></div>
    </b-container>
  </div>
</template>
<script>
import api from "@/services/api";
import { Table, TableColumn } from "element-ui";
import { exportExcel } from "@/services/utils";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      data: [],
      loading: false,
      loadingExcel: false,
      pagination: {
        page: 0,
        size: 10,
        totalElements: 0,
        totalPages: 0,
      },
    };
  },
  methods: {
    exportExcel,
    setLoadingExcel(loading) {
      this.loadingExcel = loading;
    },
    async load(page = 1) {
      this.loading = true;
      try {
        const p1 = api.get("/jurado?size=1000");
        const p2 = api.get("/peca-publicitaria?size=10000");
        const p3 = api.get("/peca-fornecedor?size=10000");
        const p4 = api.get("/peca-estudante?size=10000");

        const resps = await Promise.all([p1, p2, p3, p4]);
        const jurado = resps[0].data.data;
        const pecaPublicitaria = resps[1].data.data;
        const pecaFornecedor = resps[2].data.data;
        const pecaEstudante = resps[3].data.data;

        const response = await api.get(
          `/jurado-resposta?size=10&page=${page - 1}`
        );
        let resposta = response.data.data;
        resposta = resposta.map((r) => {
          r.nomeJurado = jurado.find((j) => j.id == r.idJurado).nome;

          if (r.idPecaPublicitaria) {
            r.pecaTituloPublicitaria = pecaPublicitaria.find(
              (p) => p.id == r.idPecaPublicitaria
            ).pecaTitulo;
          }
          if (r.idPecaFornecedor) {
            r.pecaTituloFornecedor = pecaFornecedor.find(
              (p) => p.id == r.idPecaFornecedor
            ).pecaTitulo;
          }
          if (r.idPecaEstudante) {
            r.pecaTituloEstudante = pecaEstudante.find(
              (p) => p.id == r.idPecaEstudante
            ).grupo;
          }
          return r;
        });
        this.data = resposta;
        this.pagination = response.data.pagination;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    openDeleteModal(id) {
      this.$swal
        .fire({
          title: "Tem certeza que deseja excluir?",
          text: "Isso não poderá ser revertido",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, excluir!",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.deleteData(id);
          }
        });
    },
    async deleteData(id) {
      try {
        await api.delete(`/jurado-resposta/${id}`);
        this.$swal.fire(
          "Excluído!",
          "Os dados foram excluídos com sucesso.",
          "success"
        );

        this.load();
      } catch (err) {
        console.error(err);
        this.$swal(
          "Oops!",
          "Ocorreu um problema ao excluir os dados. Por favor, tente novamente mais tarde."
        );
      }
    },
  },
  async mounted() {
    this.load();
  },
};
</script>
